import React, { memo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'antd'
import { BellOutlined } from '@ant-design/icons'
import * as Styled from './styled'
import AuthSelectors from 'modules/domain/auth/selectors'
import { Progress } from 'modules/types'
import AuthActions from 'modules/domain/auth/duck'
import useAnalyticsSafe from 'hooks/useAnalyticsSafe'
import { useAction } from '@agro-club/frontend-shared'
import SpinnerLayout from 'views/layouts/SpinnerLayout/SpinnerLayout'
import { getRoleWithPermission } from 'modules/domain/farmer/helpers'
import NotificationsDrawer from 'views/components/NotificationsDrawer/NotificationsDrawer'
import { useUserNotificationList } from 'modules/domain/userNotifications/hooks'

const ProfileButton: React.FC = memo(() => {
  const { track } = useAnalyticsSafe()
  const profileFetchProgress = useSelector(AuthSelectors.getInitProgress)
  const profile = useSelector(AuthSelectors.profile)
  const companyName = profile?.company?.internal_name
  const roleName = getRoleWithPermission(profile?.role)
  const logoutAction = useAction(AuthActions.signOutRequested)
  const [isNotificationsDrawerOpen, setIsNotificationsDrawerOpen] = useState(false)
  const [, notifications] = useUserNotificationList()
  const hasNotifications = notifications && notifications.length > 0

  const handleNotificationClick = () => {
    track('NotificationsOpened')
    setIsNotificationsDrawerOpen(true)
  }

  const handleNotificationsDrawerClose = () => {
    setIsNotificationsDrawerOpen(false)
  }

  if (profileFetchProgress === Progress.WORK) {
    return (
      <div style={{ margin: 'auto', width: 'fit-content', padding: '10px' }}>
        <SpinnerLayout />
      </div>
    )
  }

  return (
    <Styled.Wrapper>
      <Styled.NotificationButton $hasNotifications={hasNotifications}>
        <Button
          type="text"
          size="middle"
          icon={<BellOutlined />}
          onClick={handleNotificationClick}
          title="Notifications"
          className={hasNotifications ? 'notification-button-has-notifications' : 'notification-button-hover'}
          style={{ marginRight: '8px' }}
        />
      </Styled.NotificationButton>
      <Styled.UserInfoWrapper>
        <Styled.TruncateWrapper>{`${profile?.first_name || ''} ${profile?.last_name || ''}`}</Styled.TruncateWrapper>
        {!!companyName && <Styled.TruncateWrapper>{companyName}</Styled.TruncateWrapper>}
        {roleName && <Styled.TruncateWrapper>{`${roleName}`}</Styled.TruncateWrapper>}
      </Styled.UserInfoWrapper>
      <Styled.LogoutButton
        data-test-id="logout-button"
        onClick={() => {
          track('LogOut')
          logoutAction()
        }}
      >
        <Styled.StyledExit data-test-id="exit" />
      </Styled.LogoutButton>
      <NotificationsDrawer open={isNotificationsDrawerOpen} onClose={handleNotificationsDrawerClose} />
    </Styled.Wrapper>
  )
})

ProfileButton.displayName = 'ProfileButton'

export default ProfileButton
